import { useWindowSize } from '@vueuse/core';
import { computed } from 'vue';

export default function useDisplay() {
  const { width } = useWindowSize();
  const isMobile = computed(() => width.value < 600);

  return {
    isMobile,
    width,
  };
}
